import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("purchase") !== null && localStorage.getItem("purchase") !== undefined && localStorage.getItem("purchase") !== "") {

    data = JSON.parse(localStorage.getItem("purchase"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getpurchase: (state, action) => {
            localStorage.setItem("purchase", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getpurchase } = Insider.actions;
export default Insider.reducer;